//
// Bonus Multiview Bonus Strategy
// ------------------------------

define(function(require, exports, module) {
    'use strict';

    const core = require('core');
    const i18n = require('i18n');
    const config = require('config');
    const dispatcher = require('bundle').dispatcher;
    const launcher = require('modules/launcher/launcher');

    module.exports = {

        /**
         * Show popup with error if request failed
         */
        _showErrorPopup: function() {
            window.Playtech.API.popup.showPopup({
                content: i18n.t('playtech.mobile.system.error')
            });
        },

        /**
         * Show T&C popup
         * @param {Model} model
         */
        showTC: function(model) {
            model && window.Playtech.API.popup.showPopup({
                layer: 'MULTIVIEW_BONUS_TC',
                className: 'bonusmultiview-tc-popup',
                title: 'playtech.mobile.system.bonus-multi-view.tc',
                articleId: model.get('termAndConditionWebContentId')
            });
        },

        /**
         * Show buy-in overlay popup
         * @param {Model} model
         */
        showBuyInBonusOverlay: function(model) {
            if (model && model.get('type') === 'buyIn') {
                dispatcher.dispatch('bonusmultiview:bonus-details:popup:close');

                Playtech.API.popup.showPopup('bonusBuyIn', {
                    title: model.get('title'),
                    buyInWebContentId: model.get('buyInWebContentId'),
                    bonusCode: model.get('bonusCode'),
                    termAndConditionWebContentId: model.get('termAndConditionWebContentId')
                });
            }
        },

        /**
         * Proxy for get bonus
         * @param {Model} model
         */
        getBonus: function(model) {
            switch (model.get('type')) {
                case 'free':
                    this.getFreeBonus(model);
                    break;
                case 'optIn':
                    this.optIn(model);
                    break;
                case 'optOut':
                    this.optOut(model);
                    break;
                case 'buyIn':
                    this.showBuyInBonusOverlay(model);
                    break;
                case 'login':
                    this.showLoginPopup();
                    break;
                case 'join_now':
                    this.joinNow();
                    break;
                case 'deposit':
                    this.navigateToDeposit();
                    break;
                case 'custom':
                case 'campaign':
                    this.generic(model);
                    break;
                default:
                    core.error('No such bonus type: ', model.get('type'));
            }
        },

        /**
         * Get free bonus
         * @param {Model} model
         */
        getFreeBonus: function(model) {
            model && model.getFreeBonus(model.get('bonusCode'))
                .done(function(response) {
                    if ([2, 3].includes(response.data.result)) {
                        window.Playtech.API.popup.showPopup({
                            content: i18n.t('playtech.mobile.system.getFreeBonus.error.' + response.data.result)
                        });
                    }
                })
                .fail(this._showErrorPopup.bind(this));
        },

        /**
         * Opt-in to bonus
         * @param {Model} model
         */
        optIn: function(model) {
            model && model.optIn(model.get('bonusCode'), model.get('promoCode'))
                .done(function() {
                    var content = [
                        i18n.t('playtech.mobile.system.optIn.success'),
                        i18n.t('playtech.mobile.system.bonus.' + model.get('bonusCode'))
                    ];
                    var articleId = model.get('successOptInWebContentId');

                    model.set({
                        type: 'optOut',
                        actionTitle: 'playtech.mobile.system.optOut'
                    });

                    var data = articleId
                        ? { articleId }
                        : { content: content.join(' ') };
                    window.Playtech.API.popup.showPopup(data);
                })
                .fail(this._showErrorPopup.bind(this));
        },

        /**
         * Opt-out from bonus
         * @param {Model} model
         */
        optOut: function(model) {
            model && model.optOut(model.get('bonusCode'))
                .done(function() {
                    var content = [
                        i18n.t('playtech.mobile.system.optOut.success'),
                        i18n.t('playtech.mobile.system.bonus.' + model.get('bonusCode'))
                    ];

                    model.set({
                        type: 'optIn',
                        actionTitle: 'playtech.mobile.system.optIn'
                    });

                    window.Playtech.API.popup.showPopup({
                        content: content.join(' ')
                    });
                })
                .fail(this._showErrorPopup.bind(this));
        },

        /**
         * Show login popup
         */
        showLoginPopup: function() {
            core.trigger('app:message', {
                ID: 'showLogin',
                data: {
                    afterLoginUrl: window.location.pathname
                }
            });
        },

        navigateToDeposit: function() {
            var depositPage = config.get('depositPage');
            if (depositPage) {
                core.navigate(depositPage);
            }
        },

        /**
         * Handle join now button behavior
         * @return {Boolean}
         */
        joinNow: function() {
            var registrationUrl = config.get('registrationURL');
            if (registrationUrl) {
                core.navigate(registrationUrl);
            }
        },

        /**
         * Handle custom and campaign bonus behavior
         */
        generic: function(model) {
            const bonusAction = model.get('bonusAction');
            const gameCode = model.get('bonusActionGameCode');
            const bonusActionUrl = model.get('bonusActionUrl');

            if (bonusAction === 'GAME_CODE' && gameCode) {
                dispatcher.dispatch('bonusmultiview:bonus-details:popup:close');
                launcher.launchGame(gameCode, 1);
            } else if (bonusAction === 'URL' && bonusActionUrl) {
                core.navigate(bonusActionUrl);
            }
        }
    };
});
